"use client";

import RouterLink from "@/components/ui/router-link";

import { Button } from "@/components/ui/button";
import { useScopedI18n } from "@/messages/client";
import { cn } from "@/lib/utils";
import { useState } from "react";
import { DirectusImage } from "@/components/DirectusImage";
import Swiper, { SwiperSlide } from "@/components/ui/swiper";
import { Swiper as SwiperType } from "swiper/types";

function Tabs(props: {
  data: {
    title: string;
    image: string;
    link?: string;
  }[];
  active: number;
  onChange?: (index: number) => void;
}) {
  return (
    <div className="flex h-6 w-full items-center rounded-md bg-[#F8F9FE] px-1 py-0.5">
      {props.data?.map((item, index) => (
        <div
          key={index}
          onClick={() => props.onChange?.(index)}
          className={cn(
            "flex h-full flex-1 cursor-pointer items-center justify-center rounded-md text-xs text-[#71727A] transition-all duration-300",
            {
              "bg-white font-medium text-[#2C2C2C]": index === props.active,
            }
          )}>
          {item.title}
        </div>
      ))}
    </div>
  );
}

export default function ApplicationCasesClient(props: {
  data: {
    title: string;

    image: string;
    link?: string;
  }[];
  buttonText?: string;
  buttonLink?: string;
}) {
  const t = useScopedI18n("产品分类");

  const [swiper, setSwiper] = useState<SwiperType>();

  const [active, setActive] = useState(0);

  return (
    <>
      <div className="hidden items-center md:flex">
        <div className="w-[260px] flex-shrink-0 pr-8 lg:w-[300px] lg:max-w-none lg:pr-0">
          <div className="flex w-full flex-col justify-around">
            <div className="relative mb-20">
              <div className="absolute bottom-1 left-[9px] top-1 border-l border-[#E6E6E6] "></div>

              {props.data.map((item, index) => (
                <div
                  className={cn(
                    "relative flex cursor-pointer items-center space-x-2 pb-8 text-sm transition-all duration-300 last:pb-0 lg:text-base",
                    {
                      "text-base text-primary lg:text-xl": active === index,
                    }
                  )}
                  onClick={() => setActive(index)}
                  key={index}>
                  <div
                    className={cn(
                      "flex h-[1.125rem] w-[1.125rem] items-center justify-center rounded-full border border-transparent bg-white transition-colors duration-300",
                      {
                        "border-[#FFBABA]": active === index,
                      }
                    )}>
                    <div
                      className={cn(
                        "h-[0.875rem] w-[0.875rem] rounded-full border border-[#DBDBDB] transition-colors duration-300",
                        {
                          "border-primary bg-[#FF5100]": active === index,
                        }
                      )}></div>
                  </div>

                  <div className="flex items-center">
                    <span>{item.title}</span>
                  </div>
                </div>
              ))}
            </div>

            {props.buttonLink && (
              <RouterLink href={props.buttonLink}>
                <Button className="space-x-2 rounded-3xl text-lg text-white">
                  <img
                    src="/icons/case.svg"
                    alt={t("更多案例")}
                    className="h-5 w-5"
                  />
                  <span>{props.buttonText || t("更多案例")}</span>
                </Button>
              </RouterLink>
            )}
          </div>
        </div>

        <div className="relative h-[380px] flex-1 lg:h-[474px]">
          {props.data.map((item, index) => (
            <div
              className={cn(
                "absolute inset-0 hidden h-full w-full overflow-hidden rounded-lg opacity-0 shadow-[0px_4px_16px_0px_rgba(0,0,0,0.12)] transition-opacity duration-300",
                {
                  "block opacity-100": active === index,
                }
              )}
              key={index}>
              <RouterLink className="relative h-full w-full" href={item.link}>
                <DirectusImage
                  id={item.image}
                  alt={item.title}
                  fill
                  className="object-cover object-center"
                />
              </RouterLink>
            </div>
          ))}
        </div>
      </div>

      <div className="md:hidden">
        <Tabs
          data={props.data}
          active={active}
          onChange={(index) => {
            swiper?.slideTo(index);
            setActive(index);
          }}
        />

        <div className="mt-3 h-[210px]">
          <Swiper
            slidesPerView={1}
            pagination={{
              clickable: true,
              bulletClass: "swiper-pagination-bullet cases-bullet",
              bulletActiveClass:
                "swiper-pagination-bullet-active cases-bullet-active",
            }}
            onSwiper={setSwiper}
            className="h-full w-full">
            {props.data.map((item, index) => (
              <SwiperSlide key={index}>
                <RouterLink
                  href={item.link}
                  className="relative h-[180px] w-full overflow-hidden rounded-xl">
                  <DirectusImage
                    id={item.image}
                    alt={item.title}
                    fill
                    className="object-cover object-center"
                  />
                </RouterLink>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {props.buttonLink && (
          <div className="mt-4 flex justify-center">
            <RouterLink href={props.buttonLink}>
              <Button className="space-x-2 rounded-3xl text-sm text-white">
                <img
                  src="/icons/case.svg"
                  alt={t("更多案例")}
                  className="h-5 w-5"
                />
                <span>{props.buttonText || t("更多案例")}</span>
              </Button>
            </RouterLink>
          </div>
        )}
      </div>
    </>
  );
}
